import https from "./https"
import store from "@/store"

const orgId = store.state.general.organization.id

const suite = {
  list (params) {
    return https.get(`admin/organizations/${orgId}/suites`, { params })
  },
  set (params) {
    return https.post(`admin/organizations/${orgId}/suites/set`, params)
  },
  getSuites(params) {
    const searchParams = new URLSearchParams(params);

    return https.get(`/admin/system-settings/suites?${searchParams}`);
  },
  getSuiteById(orgId) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }

    return https.get(`/admin/system-settings/suites/${orgId}`);
  },
  createSuite(suite) {
    return https.post("/admin/system-settings/suites", suite);
  },
  updateSuite(orgId, suite) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }

    return https.put(
      `/admin/system-settings/suites/${orgId}`,
      suite
    );
  },
  deleteSuite(orgId) {
    if (!orgId) {
      return Promise.reject("id not found.");
    }

    return https.delete(`/admin/system-settings/suites/${orgId}`);
  },
  // Suite Package APIs
  getSuitePackages(suiteId, params) {
    if (!suiteId) {
      return Promise.reject("suite id not found.");
    }
    const searchParams = new URLSearchParams(params);
    return https.get(`/admin/system-settings/suites/${suiteId}/packages?${searchParams}`);
  },
  getSuitePackageById(suiteId, suitePackageId) {
    if (!suiteId || !suitePackageId) {
      return Promise.reject("suite id or suite package id not found.");
    }
    return https.get(`/admin/system-settings/suites/${suiteId}/packages/${suitePackageId}`);
  },
  createSuitePackage(suiteId, suitePackage) {
    if (!suiteId) {
      return Promise.reject("suite id not found.");
    }
    return https.post(`/admin/system-settings/suites/${suiteId}/packages`, suitePackage);
  },
  updateSuitePackage(suiteId, suitePackageId, suitePackage) {
    if (!suiteId || !suitePackageId) {
      return Promise.reject("suite id or suite package id not found.");
    }
    return https.put(`/admin/system-settings/suites/${suiteId}/packages/${suitePackageId}`, suitePackage);
  },
  deleteSuitePackage(suiteId, suitePackageId) {
    if (!suiteId || !suitePackageId) {
      return Promise.reject("suite id or suite package id not found.");
    }
    return https.delete(`/admin/system-settings/suites/${suiteId}/packages/${suitePackageId}`);
  },
}

export default suite
